<!--table starts-->
<section id="ng-tables">
    <div class="row text-left">
        <div class="col-12">
            <div class="content-header">Collections</div>
        </div>
    </div>
    <div class="row text-left">
        <div class="col-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <form>
                            <!-- <div class="form-group form-inline">
                                Full text search: <input class="form-control ml-2" type="text" name="searchTerm" />
                                <span class="ml-3">Loading...</span>
                            </div> -->

                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col" sortable="id">Id</th>
                                            <th scope="col" sortable="title">Title</th>
                                            <th scope="col" sortable="tags">Tags</th>
                                            <th scope="col" sortable="description">Description
                                            </th>
                                            <th scope="col" sortable="action">Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let row of rows?.rb_collections | slice: (currentPage-1) * pageSize : currentPage * pageSize">
                                            <th scope="row">{{ row.id }}</th>
                                            <td>
                                                <ngb-highlight [result]="row?.title">
                                                </ngb-highlight>
                                            </td>

                                            <td *ngIf="row?.rb_tags?.length">
                                                <span *ngFor="let tag of row.rb_tags">
                                                    <ngb-highlight [result]="tag?.name">
                                                    </ngb-highlight><span *ngIf="row?.rb_tags?.length>1">,</span>
                                                </span>
                                            </td>
                                            <td>
                                                <ngb-highlight [result]="row?.description">
                                                </ngb-highlight>
                                            </td>
                                            <td>
                                                <button type="button" class="btn btn-primary"
                                                    (click)="open(content,row)">Detail</button>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="d-flex justify-content-between p-2">
                                <ngb-pagination [collectionSize]="count" [(page)]='currentPage' [pageSize]="pageSize">
                                </ngb-pagination>

                                <!-- <select class="custom-select" style="width: auto" name="pageSize" [(ngModel)]="service.pageSize">
                    <option [ngValue]="2">2 items per page</option>
                    <option [ngValue]="4">4 items per page</option>
                    <option [ngValue]="6">6 items per page</option>
                  </select> -->
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Verify</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="mb-3">
                <label for="dateOfBirth">Enter Password</label>
                <div class="input-group">
                    <input class="form-control" placeholder="password" type="password" name="dp" [(ngModel)]='password' (keyup.enter)="detail(collection)">
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)='detail(collection)'>Save</button>
    </div>
</ng-template>
<!--Modal with Default options ends-->

<!--table ends-->